const getYearFromDateString = dateString => {
  let date = new Date('' + dateString)
  return date.getFullYear()
}

const formatDateForContentHeader = dateString => {
  let date = new Date('' + dateString)
  let day = date.getDate()
  let month = date.getMonth() + 1
  let year = date.getFullYear()

  let formattedDate = `${day < 10 ? '0' + day : day}.${month < 10 ? '0' + month : month}.${year}`
  return formattedDate
}

const dateTools = {
  getYearFromDateString,
  formatDateForContentHeader
}

export default dateTools



// WEBPACK FOOTER //
// ./src/utils/dates/dateTools.js